import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { ResponseList } from '../../../shared/models';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { UserListTabs } from '../../../hrm/pages/user-list/enums/user-list-tabs.enum';
import { UserModel } from 'common/src/models';
import { HrmService } from '../../../hrm/hrm.service';
import { OutgoingInvoiceModel } from '../../models';
import { InvoiceApiService } from '../../services/invoice-api.service';

@Component({
  selector: 'rnpl-edit-head-info-modal',
  templateUrl: './edit-head-info-modal.component.html',
})
export class EditHeadInfoModalComponent implements OnDestroy, OnChanges {

  public form: FormGroup;
  public availableEmployees: UserModel[] = [];

  @Input() invoice: OutgoingInvoiceModel;
  @Input() isReadonly: boolean = true;

  @Output() closeDialog: EventEmitter<any> = new  EventEmitter<any>();

  readonly destroy$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private readonly fb: FormBuilder,
    private readonly invoiceApiService: InvoiceApiService,
    private readonly hrmService: HrmService,
  ) {
    this.initForm();
    this.getActiveEmployees();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.hasOwnProperty('invoice') && this.invoice) {
      this.form.patchValue(this.invoice);

      if (
        !this.availableEmployees.length
        && this.invoice.properties.contactPerson.id
        && this.invoice.properties.contactPerson.type !== 'bot'
      ) {
        this.availableEmployees.push({
          avatarUrl: this.invoice.properties.contactPerson.avatar
            && this.invoice.properties.contactPerson.avatar.urlOriginal,
          first_name: this.invoice.properties.contactPerson.first_name,
          last_name: this.invoice.properties.contactPerson.last_name,
          id: this.invoice.properties.contactPerson.id
        } as any);
      }

      // if (!this.tradeOffer.properties.contactPerson.id) {
      //   this.contactPersonIdControl.patchValue(this.tradeOffer.properties.manager.id);
      // }
    }

    if (changes && changes.hasOwnProperty('isReadonly')) {
      if (this.isReadonly) {
        this.form.disable();
      } else {
        this.form.enable();
      }
    }
  }

  private getActiveEmployees(): void {
    this.hrmService.getUsers(UserListTabs.Active, '1', '10000')
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: ResponseList<UserModel>) => {
        this.availableEmployees = response.data
          .map(user => ({
            ...user,
            id: +user.id,
            searchLabel: `${user.first_name} ${user.last_name}`
          }))
          .sort((a, b) => a.searchLabel.localeCompare(b.searchLabel));
      });
  }

  public updateField(fieldValue, fieldName: string): void {
    this.invoiceApiService.updateOutgoingInvoiceField(this.invoice.invoiceId, fieldName, fieldValue)
      .subscribe(() => {
        this.invoiceApiService.getSummaryInfo(this.invoice.invoiceId).subscribe();
      }); // updated via store
  }

  public updateIssueDate(fieldValue: any): void {
    const invoice = {
      ...this.invoice,
      issueDate: new Date(fieldValue)
    };

    this.invoiceApiService.updateInvoice(invoice).subscribe(() => {});
  }

  public initForm(): void {
    this.form = this.fb.group({
      properties: this.fb.group(({
        contactPerson: this.fb.group({
          id: []
        }),
        referenceNumber: [],
      })),
      issueDate: []
    });
  }


  public close(): void {
    this.closeDialog.emit();
  }

  get contactPersonIdControl(): FormControl { return this.form.get('properties').get('contactPerson').get('id') as FormControl; }
  get issueDateControl(): FormControl { return this.form.get('issueDate') as FormControl; }
  get referenceNumberControl(): FormControl { return this.form.get('properties').get('referenceNumber') as FormControl; }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
